<template>
  <div>
    <Head-section></Head-section>
    <div class="container">
      <b-card
        v-for="comm in comms"
        :key="comm.id"
        :title="comm.title"
        :img-src="comm.cover"
        img-alt="Image"
        img-top
        tag="article"
        class="mb-2"
      >
        <b-card-text>
          <div>
            <i class="fas fa-calculator"></i>
            {{comm.createat | time}}
          </div>
          <p class="text-truncate">{{comm.content}}}</p>
        </b-card-text>

        <b-button :href="'/'+lan+'/blog/article/'+comm.id" variant="btn btn-outline-dark">{{ $t("message.Read_more") }}</b-button>
      </b-card>
    </div>

    <nav aria-label="Page navigation example ">
      <ul class="pagination justify-content-center mt-3">
        <li class="page-item">
          <a class="page-link" href="#" @click="prePage()">{{ $t("message.Previous") }}</a>
        </li>
        <li class="page-item" :class="{active:(page1-1)==pg}">
          <a class="page-link" href="#" @click="getArtLs('',page1-1)">{{page1}}</a>
        </li>
        <li class="page-item" :class="{active:(page2-1)==pg}" v-if="total>1">
          <a class="page-link" href="#" @click="getArtLs('',page2-1)">{{page2}}</a>
        </li>
        <li class="page-item" :class="{active:(page3-1)==pg}" v-if="total>2">
          <a class="page-link" href="#" @click="getArtLs('',page3-1)">{{page3}}</a>
        </li>
        <li class="page-item" :class="{active:(page4-1)==pg}" v-if="total>3">
          <a class="page-link" href="#" @click="getArtLs('',page4-1)">{{page4}}</a>
        </li>
        <li class="page-item" :class="{active:(page5-1)==pg}" v-if="total>4">
          <a class="page-link" href="#" @click="getArtLs('',page5-1)">{{page5}}</a>
        </li>
        <li class="page-item">
          <a class="page-link" href="#" @click="nextPage()">{{ $t("message.Next") }}</a>
        </li>
      </ul>
    </nav>
    <div class="d-flex justify-content-center mb-3">
      <b-spinner label="Loading..." variant="success" :class="{'d-none':spin_run}"></b-spinner>
    </div>
    <Foot-section></Foot-section>
  </div>
</template>

<script>
// import HeadSection from "./HeadCommSection.vue";
import HeadSection from "./HeadSection.vue";
import FootSection from "./FootSection.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ArticleLs",
  components: { HeadSection, FootSection },
  metaInfo() {
    return {
       title: this.$t("message.Bluedio_Mall") + " | Blog",
       titleTemplate: "%s",
      meta: [
         {
          name: "keywords",
          content: "Blog",
        }
      ],
    };
  },
  data() {
    return {
      comms: [],
      total: 0,
      total_pg: 5,
      spin_run: false,
      pg: 0,
      page1: 1,
      page2: 2,
      page3: 3,
      page4: 4,
      page5: 5,
      info: null
    };
  },
  computed: {
    ...mapGetters(["lan", "lan_array"])
  },
  watch: {
    lan(oldlan, newlan) {
      this.getArtLs("", this.pg);
    }
  },
  created() {
    let language = this.$route.params.language;
    if(this.$store.state.lan_array.indexOf(language) == -1){
      this.toHome();
    }
  },
  mounted() {
    this.getArtLs("", this.pg);
  },
  methods: {
    ...mapActions({
      getArtLs(dispatch, qry, pg) {
        this.pg = pg;
        let pgs = 20;
        this.spin_run = false;
        dispatch("getArtLs", { qry, pg, pgs }).then(data => {
          this.info = data;
          this.spin_run = data.result;
          if (data.result) {
            this.total = Math.ceil(data.total / 20);
            if (this.total <= 5) {
              this.total_pg = this.total;
            }
            this.comms = data.items;
          }
        });
      }
    }),
    nextPage() {
      if (this.pg + 1 >= this.total) return;
      if (this.pg < this.page5 - 1) {
        this.getArtLs("", this.pg + 1);
      } else {
        this.page1 = this.page1 + 5;
        this.page2 = this.page2 + 5;
        this.page3 = this.page3 + 5;
        this.page4 = this.page4 + 5;
        this.page5 = this.page5 + 5;
        this.getArtLs("", this.pg + 1);
      }
    },
    prePage() {
      if (this.pg <= 0) return;
      if (this.pg < this.page1 - 1) {
        this.getArtLs("", this.pg - 1);
      } else {
        this.page1 = this.page1 - 5;
        this.page2 = this.page2 - 5;
        this.page3 = this.page3 - 5;
        this.page4 = this.page4 - 5;
        this.page5 = this.page5 - 5;
        this.getArtLs("", this.pg - 1);
      }
    },
    toArtic(id) {
      let nameArticle = this.lan + 'BlogArticle';
      this.$router.push({
        name: nameArticle,
        params: { articleid: id }
      });
    },
    toHome() {
      let nameHome = this.lan + "home";
      this.$router.replace({
        name: nameHome
      });
    },
  }
};
</script>